import {
    BillsByCounterpartyItem,
    BillByCounterpartySortValue,
} from "@common/types/bill";
import { BillsByVendorColumn } from "@common/types/views/billViews";
import { ViewConfig } from "@lib/views";
import { VendorNameCell } from "@components/bills/views/billsByVendorView/cells/VendorNameCell";
import { DrilldownAmountCell } from "@components/bills/views/billsByVendorView/cells/DrilldownAmountCell";
import { EntitiesCell } from "@components/bills/views/billsByVendorView/cells/EntitiesCell";

export const billsByVendorViewConfig: ViewConfig<
    BillsByCounterpartyItem,
    BillsByVendorColumn,
    BillByCounterpartySortValue
> = {
    columns: {
        [BillsByVendorColumn.VENDOR]: {
            accessorKey: "counterparty",
            name: "Vendor",
            header: "Vendor",
            cell: VendorNameCell,
            sort: {
                asc: BillByCounterpartySortValue.COUNTERPARTY_ASC,
                desc: BillByCounterpartySortValue.COUNTERPARTY_DESC,
            },
            minSize: 200,
            maxSize: 400,
        },
        [BillsByVendorColumn.DUE_1_TO_30]: {
            accessorKey: "pastDue1To30",
            name: "1-30d",
            header: "1-30d",
            cell: DrilldownAmountCell,
            sort: {
                asc: BillByCounterpartySortValue.PAST_DUE_1_30_ASC,
                desc: BillByCounterpartySortValue.PAST_DUE_1_30_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [BillsByVendorColumn.DUE_31_TO_60]: {
            accessorKey: "pastDue31To60",
            name: "31-60d",
            header: "31-60d",
            cell: DrilldownAmountCell,
            sort: {
                asc: BillByCounterpartySortValue.PAST_DUE_31_60_ASC,
                desc: BillByCounterpartySortValue.PAST_DUE_31_60_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [BillsByVendorColumn.DUE_61_PLUS]: {
            accessorKey: "pastDue61Plus",
            name: "61d+",
            header: "61d+",
            cell: DrilldownAmountCell,
            sort: {
                asc: BillByCounterpartySortValue.PAST_DUE_61_PLUS_ASC,
                desc: BillByCounterpartySortValue.PAST_DUE_61_PLUS_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [BillsByVendorColumn.OVERDUE]: {
            accessorKey: "overdue",
            name: "Overdue",
            header: "Overdue",
            cell: DrilldownAmountCell,
            sort: {
                asc: BillByCounterpartySortValue.OVERDUE_ASC,
                desc: BillByCounterpartySortValue.OVERDUE_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [BillsByVendorColumn.TOTAL_OPEN]: {
            accessorKey: "open",
            name: "Open",
            header: "Open",
            cell: DrilldownAmountCell,
            sort: {
                asc: BillByCounterpartySortValue.OPEN_ASC,
                desc: BillByCounterpartySortValue.OPEN_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [BillsByVendorColumn.TOTAL_PAID]: {
            accessorKey: "paid",
            name: "Paid",
            header: "Paid",
            cell: DrilldownAmountCell,
            sort: {
                asc: BillByCounterpartySortValue.PAID_ASC,
                desc: BillByCounterpartySortValue.PAID_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [BillsByVendorColumn.BILLS_COUNT]: {
            accessorKey: "billCount",
            name: "Bills",
            header: "Bills",
            cell: DrilldownAmountCell,
            sort: {
                asc: BillByCounterpartySortValue.BILLS_COUNT_ASC,
                desc: BillByCounterpartySortValue.BILLS_COUNT_DESC,
            },
            minSize: 100,
            maxSize: 200,
        },
        [BillsByVendorColumn.ENTITIES]: {
            accessorKey: "entityIds",
            name: "Entities",
            header: "",
            cell: EntitiesCell,
            minSize: 100,
            maxSize: 200,
        },
    },
};
